import { Toast } from "primereact/toast"
import { useEffect, useRef } from "react"
import { VIEW_ONLY_EVENT } from "utils/viewOnly"

// One app-wide notice for a write the API refused because the user has view
// only access (see utils/viewOnly.ts). Mounted once, in AppWrapper.
const ViewOnlyToast = () => {
    const toastRef = useRef<Toast>(null)

    useEffect(() => {
        const show = () =>
            toastRef.current?.show({
                severity: "warn",
                summary: "View only",
                detail: "You have view-only access here, so this change was not saved.",
                life: 6000,
            })
        window.addEventListener(VIEW_ONLY_EVENT, show)
        return () => window.removeEventListener(VIEW_ONLY_EVENT, show)
    }, [])

    return <Toast ref={toastRef} />
}

export default ViewOnlyToast
